import { useNotificationStore } from '../store'
import { INotification } from '../types'

export const useNotification = () => {
    const { enqueueNotification } = useNotificationStore()

    const showNotification = (notification: INotification) => {
        enqueueNotification(notification)
    }

    return { showNotification }
}
